"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeAttemptMethod = void 0;
/**
 * Normalized income-verification *attempt method* token for the partner dashboard income card's
 * attempts table. The backend classifies its two internal origination enums
 * (`IncomeVerificationMethod` for automatic attempts, `IncomeVerificationDocumentType` for uploaded
 * documents) INTO this single domain enum; the frontend maps each token to a display string via
 * Paraglide (incomeLabels.ts). This mirrors the blessed pattern used by
 * `IncomeVerificationStatus` — backend emits domain tokens, frontend owns wording — so the broker
 * contract never leaks the larger, churn-prone internal origination taxonomy.
 *
 * Values are *domain categories*, never display strings: `bankConnection` (not "Bank Connection").
 * Overlapping internal tokens collapse here by design (e.g. `plaid` and `PLAID` both →
 * `bankConnection`; `TAX_RETURN` and `STATE_TAX_RETURN` → `taxReturn`). `other` is the
 * exhaustive-switch safety net for internal tokens that are not real
 * displayable attempt evidence (e.g. `STATED_INCOME`, `IGNORED_DOC`, `unknown`); the classifier is
 * exhaustive over both internal enums so a newly-added origination token is a compile error, not a
 * silently-dropped attempt.
 */
var IncomeAttemptMethod;
(function (IncomeAttemptMethod) {
    IncomeAttemptMethod["bankConnection"] = "bankConnection";
    IncomeAttemptMethod["payStub"] = "payStub";
    IncomeAttemptMethod["w2"] = "w2";
    IncomeAttemptMethod["taxReturn"] = "taxReturn";
    IncomeAttemptMethod["form1099"] = "form1099";
    IncomeAttemptMethod["bankStatement"] = "bankStatement";
    IncomeAttemptMethod["profitAndLoss"] = "profitAndLoss";
    IncomeAttemptMethod["socialSecurity"] = "socialSecurity";
    IncomeAttemptMethod["pension"] = "pension";
    IncomeAttemptMethod["retirement"] = "retirement";
    IncomeAttemptMethod["irs"] = "irs";
    IncomeAttemptMethod["workNumber"] = "workNumber";
    IncomeAttemptMethod["experian"] = "experian";
    IncomeAttemptMethod["other"] = "other";
})(IncomeAttemptMethod || (exports.IncomeAttemptMethod = IncomeAttemptMethod = {}));
